export default "__VITE_ASSET__BhBdpDp5__"